import React from "react";
import { Link } from "react-router-dom";
import classes from "./footer.module.scss";

const FooterBottom = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className={classes.footer_bottom}>
      <div className={classes.footer_bottom_inner}>
        <div className={classes.footer_bottom_links}>
          <Link to={`${process.env.PUBLIC_URL}/terms-and-conditions`}>
            Terms and Conditions
          </Link>
          <Link to={`${process.env.PUBLIC_URL}/privacy-policy`}>
            Privacy Policy
          </Link>
        </div>
        <p className={classes.copyright}>
          &copy; {currentYear} Sunny Diamonds. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default FooterBottom;
